import React from "react";
import { Link } from "react-router-dom";
import { useAgentAccess } from "@/hooks/useAgentAccess";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  FileText,
  Sparkles,
  ArrowRight,
  Layers,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { AGENT_CATALOG } from "@/lib/agent-catalog";

export default function AIAgentsSection() {
  const { isLoading, error, agents } = useAgentAccess();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-16">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-3 border-legal-blue border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-gray-400">Cargando agentes...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <Card className="border-red-200 bg-red-50">
          <CardContent className="p-6">
            <div className="text-red-600">
              Error al cargar los agentes: {error}
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-6">
      <div className="flex items-center gap-3 mb-6">
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900">Mis Agentes IA</h3>
        {/* <Badge className="bg-gradient-to-r from-legal-blue to-legal-navy text-white border-none px-3 py-0.5 text-xs font-semibold animate-pulse-subtle">
          Beta
        </Badge> */}
      </div>

      {/* Dynamic Grid of Agents */}
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">

        {agents && agents.length > 0 && Array.isArray(agents) && (() => {
            const list = [...(agents || [])];
            // if (list.some(a => a.id === "legal-chatbot") && !list.some(a => a.id === "legal-chatbot-v2")) {
            //   list.push({ id: "legal-chatbot-v2", name: "Chatbot Legal RAG (V2)", description: "Consultas RAG ultra-rápidas directamente vinculadas a la KB.", is_visible: true } as any);
            // }
            return list;
          })()
          .filter(agent => agent.id !== "specialized") // Avoid duplicates if already in DB
          .map((agent, index) => {
            const config = AGENT_CATALOG[agent.id];
            const AgentIcon = config?.icon || FileText;
            const name = config?.name || agent.name;
            const description = config?.description || agent.description;

            return (
              <Link to={config?.path || "#"} key={agent.id}>
                <Card className={`group h-full border border-gray-100/80 bg-white hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden animate-fade-in-up stagger-${index + 1}`}>
                  <CardHeader className="pb-3">
                    <div className="flex items-center justify-between mb-3">
                      <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${config?.gradient || 'from-gray-500 to-gray-600'} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                        <AgentIcon className="h-5 w-5 text-white" />
                      </div>
                      {/* <Badge
                        variant="secondary"
                        className="bg-blue-50 text-blue-600 text-[10px] font-semibold px-2 py-0.5 border-none">
                        Beta
                      </Badge> */}
                    </div>
                    <CardTitle className="text-base font-semibold text-gray-900 leading-tight border-none">
                      {name}
                    </CardTitle>
                    <CardDescription className="text-xs text-gray-400 mt-1 line-clamp-2">
                      {description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <div className="flex items-center justify-end">
                      <span className="text-xs font-medium text-legal-blue group-hover:text-legal-navy flex items-center gap-1 transition-colors">
                        Abrir <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 transition-transform" />
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            );
          })}

        {(!agents || agents.length === 0) && (
          <Card className="mt-6 border-dashed border-2 border-gray-200">
            <CardContent className="pt-8 pb-8 text-center">
              <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                <Sparkles className="h-6 w-6 text-gray-400" />
              </div>
              <p className="text-gray-500 text-sm">No tienes más agentes IA activos en tu suscripción actual.</p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
